import * as React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';

const CustomLinearProgress = (props) => {
    return <LinearProgress {...props} />;
};

export { CustomLinearProgress as LinearProgress };
